const CONTACT_US_WINCHESTER = '<div><p>Lane Clark &amp; Peacock LLP<br/>St Paul’s House<br/>St Paul’s Hill, Winchester<br/>Hampshire<br/>SO22 5AB </p></div>';

export default CONTACT_US_WINCHESTER;
